import React from 'react';
import { ConfigHelper } from '../../config/ConfigHelper';
import configJson from './research-reports-search-config.json';
import { stringOrDefault } from '../../utils';
import ResultView, {
  title,
  titleContents,
  wrapper,
  attribute,
  attributeLabel,
  attributeValue,
  featuredLabel,
} from '../../components/ResultView';
import { trackSearchResultClick } from '../../utils/dataLayer';
import { withSearch } from '@elastic/react-search-ui';

const configHelper = new ConfigHelper(configJson);

function ResearchReportsSearchResultView({
  current,
  onClickLink,
  result,
  resultsPerPage,
  searchTerm,
}) {
  if (result.path === undefined) {
    return null;
  }

  const attributes = [
    {
      label: 'Report No',
      value: stringOrDefault(result.id, undefined),
    },
    {
      label: 'Date published',
      value: stringOrDefault(result.date, undefined),
    },
  ];

  const content = (
    <div className={wrapper}>
      {result.featured === true && (
        <div className={featuredLabel}>Featured result</div>
      )}
      <h2
        className={title}
        data-featured-result={result.featured === true ? '' : undefined}
      >
        <span className={titleContents}>
          <a
            dangerouslySetInnerHTML={{ __html: result.name }}
            href={configHelper.getBaseURLField() + result.path}
            onClick={() => {
              trackSearchResultClick(
                result._meta.id,
                result._meta.resultNumber,
                result.name,
                result.path,
                current,
                resultsPerPage,
                searchTerm,
              );
              onClickLink();
            }}
          />
        </span>
      </h2>

      {result.summary && (
        <div
          className={attribute}
          dangerouslySetInnerHTML={{ __html: result.summary }}
        />
      )}

      {attributes
        .filter(item => item.value !== undefined)
        .map((item, index) => (
          <div className={attribute} key={index}>
            <div className={attributeLabel}>{item.label}:</div>
            <div
              className={attributeValue}
              dangerouslySetInnerHTML={{ __html: item.value }}
            />
          </div>
        ))}
    </div>
  );

  return <ResultView>{content}</ResultView>;
}

export default withSearch(({ current, resultsPerPage, searchTerm }) => ({
  current,
  resultsPerPage,
  searchTerm,
}))(ResearchReportsSearchResultView);
